import { render, staticRenderFns } from "./revenueinvestment.vue?vue&type=template&id=cd325a80&scoped=true&"
import script from "./revenueinvestment.vue?vue&type=script&lang=js&"
export * from "./revenueinvestment.vue?vue&type=script&lang=js&"
import style0 from "./revenueinvestment.vue?vue&type=style&index=0&id=cd325a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd325a80",
  null
  
)

export default component.exports